import { render, staticRenderFns } from "./TabSummary.vue?vue&type=template&id=af662bde&"
import script from "./TabSummary.vue?vue&type=script&lang=js&"
export * from "./TabSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports